import { Typography, type TypographyProps } from "@mui/material";
import type React from "react";
import { useTranslation } from "react-i18next";
import type { TFuncKey } from "../../i18n";

export interface InfoTextProps extends TypographyProps {
	translation: TFuncKey;
}

export const InfoText: React.FC<InfoTextProps> = ({
	translation,
	...attributes
}) => {
	const { t } = useTranslation();

	return (
		<Typography variant="body1" m={4} textAlign="center" {...attributes}>
			{t(translation)
				.split("\n")
				.map((s) => (
					<>
						{s}
						<br />
					</>
				))}
		</Typography>
	);
};
